<template>
    <div class="h-wrapper">
        <div class="content">
            <div class="content-layout">
                <div class="login-form">
                    <div class="logo-area">
                        <div class="logo-container">
                            <img src="../assets/platform-logo.png" alt="缺失logo图片"><span class="desc">建筑工人实名制管理系统</span>
                        </div>
                    </div>
                    <div class="form h-form-box">
                        <div class="title">账号密码登录</div>
                        <Form ref="formLogin" :model="formLogin" :rules="ruleLogin">
                            <FormItem prop="userName" >
                                <Input autofocus prefix="md-person" type="text" size="large"  v-model="formLogin.userName" @on-focus="userIcon=true" @on-blur="userIcon=false" :class="{'userIcon':userIcon}">
                                </Input>
                            </FormItem>
                            <FormItem prop="password" class="ssss" data-pwd>
                                <Input prefix="md-lock" type="password" password size="large" @keyup.enter.native="login('formLogin')"  v-model="formLogin.password" @on-focus="passIcon=true" @on-blur="passIcon=false" :class="{'passIcon':passIcon}" >
                                </Input>
                            </FormItem>
                            <div class="h-login-btn">
                                <Button type="primary" long size="large"  @click="login('formLogin')" >登录</Button>
                                <!--<Button type="text" long size="large"  @click="regist" >注册</Button>-->
                            </div>
                        </Form>
                        <div class='my-request'>
                              <span style="cursor: pointer;font-weight:500;" @click="openDockingQuery">项目对接查询</span>
                            <!--<span style="cursor: pointer" @click="handleMyRequest">秘钥申请</span>-->
                            <span style="cursor: pointer" @click="openInfoModal">项目信息登记</span>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="copyright-container">
                <span class="copyright">&nbsp;&nbsp;&nbsp;©2021 广联达科技股份有限公司&nbsp;&nbsp;&nbsp;</span>
            </div>-->
        </div>
        <Modal v-model="registerModal" class-name="centerModal" width="600">
            <p slot="header">
                <span style="font-size: 16px;color: #FF8400">注册提示</span>
            </p>
            <div style="font-size: 15px;line-height: 25px">
                <p> 1.此账号注册功能 <strong>仅限建设（甲方、业主）单位使用，仅用于项目报建相关业务，</strong>    施工企业、房地产开发等其他企业需要使用企业锁登录，不能注册账号;</p>
                <p>2.注册时必须填写组织机构代码和社会统一信用代码，否则无法正常办理业务;</p>
                <p>3.账号注册后需要审核，审核通过申请人会收到短信通知。</p>
            </div>
            <div slot="footer" style="text-align: center">
                <!--<router-link to="/register">-->
                    <Button type="primary" :disabled="timeing" @click="handleAgree">
                        同意
                        <span v-if="timeing">({{num}})</span>
                    </Button>
                <!--</router-link>-->
                <Button type="primary" @click="registerModal=false">不同意</Button>
            </div>
        </Modal>
        <Modal
            v-model="myVisiable"
            title="项目秘钥申请"
            :loading="loading"
            :footer-hide='true'
            :mask-closable='false'
            width='800'
        >
            <Form ref="modeForm" :model="modeForm" :rules="modeFormRules" :label-width="210">
                <FormItem label="请选择监管单位:" prop="adminId">
                    <Cascader :value="modeForm.adminId" :data="adminList" placeholder="请选择监管单位" @on-change='handleAdminChange'></Cascader>
                </FormItem>
                <FormItem label="项目名称:" prop="projectName">
                    <Input v-model="modeForm.projectName" placeholder="请输入项目名称"></Input>
                </FormItem>
                <FormItem label="工程类别:" prop="projectType">
                    <RadioGroup v-model="modeForm.projectType">
                        <Radio label="1" value='1'>房建</Radio>
                        <Radio label="2" value='2'>市政</Radio>
                        <Radio label="3" value='3'>其他</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="所在地区:" prop="areacode">
                    <Cascader :value="modeForm.areacode" :data="areaList" change-on-select placeholder="请选择所在地区" @on-change='handleCasChange'></Cascader>
                </FormItem>
                <FormItem label="软件供应商:">
                    <Row>
                        <Col span="6">
                            <RadioGroup v-model="modeForm.supplier">
                                <Radio :label="1">有</Radio>
                                <Radio :label="0">无</Radio>
                            </RadioGroup>
                        </Col>
                        <Col span="18" v-if='showSupplierName'>
                            <FormItem label='软件供应商名称:' prop="supplierName" :label-width="140">
                                <Input style="width: 278px;" v-model="modeForm.supplierName" placeholder="请输入软件供应商名称"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem label='建设单位:' prop="constructionName">
                    <Input v-model="modeForm.constructionName" placeholder="请输入建设单位"></Input>
                </FormItem>
                <FormItem label='施工单位:' prop="buildName">
                    <Input v-model="modeForm.buildName" placeholder="请输入施工单位"></Input>
                </FormItem>
                <FormItem label='施工单位统一社会信用代码:' prop="buildCreditCode">
                    <Input v-model="modeForm.buildCreditCode" placeholder="请输入施工单位统一社会信用代码"></Input>
                </FormItem>
                <FormItem label='申请人姓名:' prop="applicantName">
                    <Input v-model="modeForm.applicantName" placeholder="请输入申请人姓名"></Input>
                </FormItem>
                <FormItem label='联系电话:' prop="applicantMobile">
                    <Input v-model="modeForm.applicantMobile" placeholder="请输入联系电话" style="width: 80%;"></Input>
                    <Button type="primary" @click="sendMsg" :disabled='msg != "发送验证码"' style="width: 20%;">{{msg}}</Button>
                </FormItem>
                <FormItem label='短信验证码:' prop="validCode">
                    <Input v-model="modeForm.validCode" placeholder="请输入短信验证码"></Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="asyncOK" style="width: 45%; margin-right: 10%">提交</Button>
                    <Button @click="asyncCancel" style="width: 45%">取消</Button>
                </FormItem>
            </Form>
        </Modal>
        <Modal
                v-model="infoVisiable"
                title="项目信息登记"
                :footer-hide='true'
                :mask-closable='false'
                width="75"
                class-name="info__modal"
        >
            <Form ref="infoForm" :model="infoForm" :rules="infoFormRules" inline :label-width="240"  class="form-list key__form">
                <Row :gutter="16">
                    <Col span="12">
                        <FormItem label="项目名称" prop="name">
                            <Input v-model="infoForm.name" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="施工许可证号" prop="buildPermitCode">
                            <Input v-model="infoForm.buildPermitCode" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目所在地区" prop="areaCodeS">
                            <Cascader v-model="infoForm.areaCodeS" :data="areaList" placeholder="请选择" @on-change='infoCas'></Cascader>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目类别" prop="projectType">
                            <Select v-model="infoForm.projectType" filterable clearable label-in-value @on-change="infoType">
                                <Option v-for="item in common.projectTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="项目状态" prop="prjStatus">
                            <RadioGroup v-model="infoForm.prjStatus">
                                <Radio v-for="item in common.prjStatusS" :label="item.value">{{item.label}}</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目开工日期（计划开工日期）" prop="startDate">
                            <DatePicker type="date" placeholder="请选择" :value="infoForm.startDate" @on-change="infoForm.startDate=$event"
                                        :options="{ disabledDate: val => { return this.disabledDateStart(val, infoForm.completeDate)} }"
                                        transfer></DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目竣工日期（计划竣工日期）" prop="completeDate">
                            <DatePicker type="date" placeholder="请选择" :value="infoForm.completeDate" @on-change="infoForm.completeDate=$event"
                                        :options="{ disabledDate: val => { return this.disabledDateEnd(val, infoForm.startDate)} }"
                                        transfer></DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="总投资（万元）" prop="invest">
                            <Input v-model="infoForm.invest" type="number" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="总面积（平方米）" prop="buildingArea">
                            <Input v-model="infoForm.buildingArea" type="number" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="施工总承包单位名称" prop="contractorCorpName">
                            <Input v-model="infoForm.contractorCorpName" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="施工总承包单位统一社会信用代码" prop="contractorCorpCode">
                            <Input v-model="infoForm.contractorCorpCode" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目经理" prop="pmName">
                            <Input v-model="infoForm.pmName" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="pmPhone">
                            <Input v-model="infoForm.pmPhone" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="建设单位名称" prop="buildCorpName">
                            <Input v-model="infoForm.buildCorpName" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="建设单位统一社会信用代码" prop="buildCorpCode">
                            <Input v-model="infoForm.buildCorpCode" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="建设单位项目负责人" prop="supervisingEngineerName">
                            <Input v-model="infoForm.supervisingEngineerName" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="supervisingEngineerPhone">
                            <Input v-model="infoForm.supervisingEngineerPhone" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="监理单位名称" prop="adminName">
                            <Input v-model="infoForm.adminName" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="监理单位统一社会信用代码" prop="adminId">
                            <Input v-model="infoForm.adminId" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目总监" prop="projectDirector">
                            <Input v-model="infoForm.projectDirector" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="projectDirectorPhone">
                            <Input v-model="infoForm.projectDirectorPhone" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <!--<Col span="12">-->
                        <!--<FormItem label="总监理工程师" prop="supervisingEngineerName">-->
                            <!--<Input v-model="infoForm.supervisingEngineerName" placeholder="请输入"></Input>-->
                        <!--</FormItem>-->
                    <!--</Col>-->
                    <Col span="12">
                        <FormItem label="设备安装公司名称" prop="equipmentCompanyName">
                            <Input v-model="infoForm.equipmentCompanyName" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="设备安装公司电话" prop="equipmentCompanyMobile">
                            <Input v-model="infoForm.equipmentCompanyMobile" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目实名制负责人姓名" prop="applicantName">
                            <Input v-model="infoForm.applicantName" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目实名制负责人联系电话" prop="applicantMobile">
                            <Input v-model="infoForm.applicantMobile" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目实名制负责人邮箱" prop="email">
                            <Input v-model="infoForm.email" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="备注" prop="remark">
                            <Input v-model="infoForm.remark" type="textarea" :rows="3" placeholder="请输入"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <div style="text-align: center">
                    <Button type="primary" :loading="loadingK" @click="infoOk" style="width: 100px; margin-right: 20px">提 交</Button>
                    <Button @click="infoCancel" style="width: 100px;" >取 消</Button>
                </div>
            </Form>
        </Modal>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { getCounties } from '../api/user'
    export default {
        name: 'login',
        data(){
            const valiuserName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写用户名!'));
                }else {
                    callback();
                }
            };
            const valipassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写密码!'));
                }else {
                    callback();
                }
            };
            const validAreacode = (rule, value, callback) => {
                const { provinceCode, cityCode, countyCode } = this.modeForm
                if (provinceCode || cityCode || countyCode) {
                    callback()
                } else {
                    callback(new Error('请选择省市区'))
                }
            }
            const validStrForPhoneNum = (rule, value, callback) => {
                let r = ''
                const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
                if (value === '' || value === undefined) {
                    r = '请输入手机号'
                } else if (typeof value === 'string' && !reg.test(value)) {
                    r = '手机号格式错误'
                }
                if (r) {
                    callback(new Error(r))
                } else {
                    callback()
                }
            }
            return {
                // 项目信息登记 <
                infoVisiable: false,
                loadingK: false,
                infoForm:{
                    name: '',
                    buildPermitCode: '',
                    areaCodeS: [],
                    provinceCode: '',
                    provinceName: '',
                    cityCode: '',
                    cityName: '',
                    countyCode: '',
                    countyName: '',
                    // areaCode: '',
                    // areaName: '',
                    projectType: '',
                    projectTypeName: '',
                    prjStatus: '',
                    contractorCorpName: '',
                    contractorCorpCode: '',
                    startDate: '',
                    completeDate: '',
                    invest: '',
                    buildingArea: '',
                    buildCorpName: '',
                    buildCorpCode: '',
                    pmName: '',
                    supervisingEngineerName: '',
                    equipmentCompanyName: '',
                    equipmentCompanyMobile: '',
                    applicantName: '',
                    applicantMobile: '',
                    email: '',
                    remark: '',
                    pmPhone: '',
                    supervisingEngineerPhone: '',
                    adminName: '',
                    adminId: '',
                    projectDirector: '',
                    projectDirectorPhone: '',
                },
                infoFormRules: {
                    name: [
                        { required: true,  message: '请输入项目名称', trigger: 'blur' }
                    ],
                    areaCodeS: [
                        { required: true, type:'array', min: 1, message: '项目所在地区不能为空', trigger: 'change' }
                    ],
                    projectType: [
                        { required: true,  message: '项目类别不能为空', trigger: 'change' }
                    ],
                    prjStatus: [
                        { required: true,  message: '项目状态不能为空', trigger: 'change' }
                    ],
                    contractorCorpName: [
                        { required: true,  message: '请输入施工总承包单位名称', trigger: 'blur' }
                    ],
                    contractorCorpCode: [
                        { required: true,  message: '请输入施工总承包单位统一社会信用代码', trigger: 'blur' }
                    ],
                    pmName: [
                        { required: true,  message: '请输入项目经理', trigger: 'blur' }
                    ],
                    buildCorpName: [
                        { required: true,  message: '请输入建设单位名称', trigger: 'blur' }
                    ],
                    buildCorpCode: [
                        { required: true,  message: '请输入建设单位统一社会信用代码', trigger: 'blur' }
                    ],
                    supervisingEngineerName: [
                        { required: true,  message: '请输入建设单位项目负责人', trigger: 'blur' }
                    ],
                    adminName: [
                        { required: true,  message: '请输入监理单位名称', trigger: 'blur' }
                    ],
                    adminId: [
                        { required: true,  message: '请输入监理单位统一社会信用代码', trigger: 'blur' }
                    ],
                    projectDirector: [
                        { required: true,  message: '请输入项目总监', trigger: 'blur' }
                    ],
                    applicantName: [
                        { required: true, message: '请输入项目实名制负责人姓名', trigger: 'blur' }
                    ],
                    applicantMobile: [
                        { required: true, validator: validStrForPhoneNum, trigger: 'blur' }
                    ],
                    email: [
                        { required: true, message: '邮箱地址不能为空', trigger: 'blur' },
                        { type: 'email', message: '邮箱地址格式不正确', trigger: 'blur' }
                    ],
                },
                // >
                areaList: [],
                showSupplierName: true,
                msg: '发送验证码',
                // 注册
                loading: false,
                registerModal:false,
                myVisiable: false,
                timeing:true,
                num:6,
                timeout:null,
                userIcon:false,
                passIcon:false,
                adminList: [],
                //
                loginType: 'tenant',
                formLogin:{
                    userName: '',
                    password: '',
                },
                ruleLogin: {
                    userName: [
                        { validator: valiuserName, trigger: 'blur' }
                    ],
                    password: [
                        { validator: valipassword, trigger: 'blur' },
                    ]
                },
                modeForm: {
                    adminId: [], // 监管单位id
                    adminName: '', // 监管单位名称
                    projectName: '', // 项目名称
                    projectType: '1', // 工程类别
                    projectTypeName: '', // 工程类别名称
                    provinceCode: '', // 所在地区省code
                    provinceName: '', // 所在地区省名称
                    cityCode: '', // 所在地区市code
                    cityName: '', // 所在地区市名称
                    countyCode: '', // 所在地区县code
                    countyName: '', // 所在地区县名称
                    supplier: 1, // 是否有供应商0否，1是
                    supplierName: '', // 供应商名称
                    constructionName: '', // 建设单位
                    buildName: '', // 施工单位
                    buildCreditCode: '', // 施工单位统一社会信用代码
                    applicantName: '', // 申请人姓名
                    applicantMobile: '', // 联系电话
                    areacode: [],
                    validCode: ''
                },
                modeFormRules: {
                    projectName: [
                        { required: true, message: '请输入项目名称', trigger: 'change' }
                    ],
                    projectType: [
                        { required: true, message: '请选择工程类别', trigger: 'change' }
                    ],
                    areacode: [
                        { required: true, validator: validAreacode, trigger: 'change' }
                    ],
                    supplierName: [
                        { required: true, message: '请输入软件供应商名称', trigger: 'change' }
                    ],
                    constructionName: [
                        { required: true, message: '请输入建设单位', trigger: 'change' }
                    ],
                    buildName: [
                        { required: true, message: '请输入施工单位', trigger: 'change' }
                    ],
                    buildCreditCode: [
                        { required: true, message: '请输入施工单位统一社会信用代码', trigger: 'change' }
                    ],
                    applicantName: [
                        { required: true, message: '请输入申请人姓名', trigger: 'change' }
                    ],
                    applicantMobile: [
                        { required: true, validator: validStrForPhoneNum, trigger: 'change' }
                    ],
                    validCode: [
                        { required: true, message: '请输入短信验证码', trigger: 'change' }
                    ]
                }
            };
        },
        created() {
            // this.getKeyData();
        },
        watch: {
            'registerModal': function () {
                if(!this.registerModal){
                    this.num=6;
                    clearTimeout(this.timeout);
                }

            },
            'modeForm.supplier': function(val) {
                this.showSupplierName = false
                if(!val) {
                    this.modeFormRules.supplierName = []
                    this.modeForm.supplierName = ''
                } else {
                    this.modeFormRules.supplierName = [
                        { required: true, message: '请输入软件供应商名称', trigger: 'change' }
                    ]
                }
                this.$nextTick(() => {
                    this.showSupplierName = true
                })
            },
            myVisiable(val) {
                if(!val) {
                    this.asyncCancel()
                }
            },
            // 项目信息登记
            infoVisiable(val) {
                if(!val) {
                    this.infoCancel()
                }
            }
        },
        methods: {
            ...mapActions(['GetCitys']),
            disabledDateStart(val, date) {
                return (
                    new Date(date || '').getTime() - 24 * 3600 * 1000 < val.getTime()
                );
            },
            disabledDateEnd(val, date) {
                return (
                    new Date(date || '').getTime() > val.getTime()
                );
            },
            // 项目对接查询
            openDockingQuery() {
                this.$router.push({
                    name: "projectDetailDockingQuery",
                    // query: {
                    //   areaCode: row.areaCode,
                    //   type: type,
                    //   startDate: this.formInline.startDate,
                    //   endDate: this.formInline.endDate,
                    // },
                });
            },
            // 项目信息登记 <
            openInfoModal(){
                this.infoVisiable = true;
                getCounties('000000').then((res)=> {
                    this.areaList = res.data.data || []
                });
            },
            infoType(data){
                this.infoForm.projectTypeName = data.label;
            },
            infoCas(val, data) {
                const len = data.length;
                this.infoForm.provinceCode = data[len-3].value;
                this.infoForm.provinceName = data[len-3].label;
                this.infoForm.cityCode = data[len-2].value;
                this.infoForm.cityName = data[len-2].label;
                this.infoForm.countyCode = data[len-1].value;
                this.infoForm.countyName = data[len-1].label;
            },
            infoOk(){
                this.$refs.infoForm.validate((valid) => {
                    if (valid) {
                        this.loadingK = true;
                        this.axios({
                            method: 'post',
                            url:'/project/applySecretKey',
                            data: this.infoForm
                        }).then((res) => {
                            this.loadingK = false;
                            if (res.data.success) {
                                this.infoCancel();
                                this.$Modal.info({
                                    title: '提示',
                                    content: '您的项目已经登记成功，请您耐心等待主管单位审核，审核通过您预留的实名制负责人联系电话以及邮箱地址会收到本项目的秘钥信息，请您注意查收。项目秘钥信息用于实名制数据对接使用，项目方无需登录系统。谢谢。'
                                });
                            } else {
                                this.$Modal.error({
                                    title: '提示',
                                    content: '申请失败，失败原因：' + res.data.errorMsg
                                })
                            }
                        }).catch(() => {
                            this.loadingK = false;
                        });
                    }
                })
            },
            infoCancel(){
                this.$refs.infoForm.resetFields();
                this.infoVisiable = false;
            },
           // >
            // 秘钥数据
            getKeyData() {
                this.axios({
                    method: 'get',
                    url:'/project/dictAdmin',
                }).then( (res)=> {
                    this.adminList = flat(res.data.data) || []
                    function flat(arr) { // map 也可以
                        return arr.reduce((sum, it) => {
                            it.value = it.id
                            it.label = it.name
                            if (it.children) {
                                it.children = flat(it.children)
                            } else {
                                it.children = []
                            }
                            sum.push(it);
                            return sum
                        }, [])
                    }
                });
                this.axios({
                    method: 'get',
                    url:'/dict/counties',
                }).then( (res)=> {
                    this.areaList = res.data.data || []
                });
            },
            sendMsg() {
                let r = ''
                const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
                if (!this.modeForm.applicantMobile || !reg.test(this.modeForm.applicantMobile)) {
                    return this.$refs.modeForm.validateField('applicantMobile')
                }
                this.msg = '正在发送60s'
                let i = 59
                this.timer = setInterval(() => {
                    this.msg = '正在发送' + i + 's'
                    if(i === -1) {
                        this.msg = '发送验证码'
                        return clearInterval(this.timer)
                    }
                    i--
                }, 1000)
                this.axios({
                    method: 'post',
                    data: {
                        applicantMobile: this.modeForm.applicantMobile
                    },
                    url:'/project/sendSmsCode',
                }).then( (res)=> {
                    // console.log(res, '发送验证码')
                });
            },
            login(formLogin){
                this.$refs[formLogin].validate((valid) => {
                    if(valid){
                        this.$store.dispatch('users/userLogin',{
                            'account':this.formLogin.userName,
                            'password':this.formLogin.password,
                            'loginType':this.loginType,
                        }).then((res)=>{
                            if (res.data.success){
                                this.$router.push({ name: 'base' });
                            }else {
                                switch (res.data.errorMsg) {
                                    case 'password_error':
                                        this.$Message.error('用户名或密码错误!');
                                        break;
                                    case 'useraccount_error':
                                        this.$Message.error('用户名不存在!');
                                        break;
                                    default:
                                        this.$Message.error(res.data.errorMsg);
                                }
                            }
                        });
                    }
                });
            },
            handleCasChange(value, selectedData) {
                this.modeForm.areacode = value
                this.modeForm.provinceCode = value[0] || ''
                this.modeForm.cityCode = value[1] || ''
                this.modeForm.countyCode = value[2] || ''
                this.modeForm.provinceName = selectedData[0] && selectedData[0].label || ''
                this.modeForm.cityName = selectedData[1] && selectedData[1].label || ''
                this.modeForm.countyName = selectedData[2] && selectedData[2].label || ''
            },
            handleAdminChange(val, selectedData) {
                this.modeForm.adminId = val
            },
            asyncOK() {
                const param = {
                    ...this.modeForm,
                    projectTypeName: this.modeForm.projectType == '1' ? '房建' : this.modeForm.projectType == '2' ? '市政' : '其他',
                    adminId: this.modeForm.adminId[this.modeForm.adminId.length - 1]
                }
                const { areacode, ...rest } = param
                this.$refs.modeForm.validate((valid) => {
                    if (valid) {
                        this.axios({
                            method: 'post',
                            url:'/project/applySecretKey',
                            data: rest
                        }).then((res) => {
                            if (res.data.success) {
                                this.$Message.success({
                                    content: '申请成功'
                                })
                                this.asyncCancel()
                            } else {
                                this.$Message.warning({
                                    content: res.data.errorMsg || '申请失败'
                                })
                            }
                        })
                    }
                })
            },
            asyncCancel() {
                this.$refs.modeForm.resetFields()
                this.myVisiable = false
                this.modeForm = {
                    adminId: [], // 监管单位id
                    adminName: '', // 监管单位名称
                    projectName: '', // 项目名称
                    projectType: '1', // 工程类别
                    projectTypeName: '', // 工程类别名称
                    provinceCode: '', // 所在地区省code
                    provinceName: '', // 所在地区省名称
                    cityCode: '', // 所在地区市code
                    cityName: '', // 所在地区市名称
                    countyCode: '', // 所在地区县code
                    countyName: '', // 所在地区县名称
                    supplier: 1, // 是否有供应商0否，1是
                    supplierName: '', // 供应商名称
                    constructionName: '', // 建设单位
                    buildName: '', // 施工单位
                    buildCreditCode: '', // 施工单位统一社会信用代码
                    applicantName: '', // 申请人姓名
                    applicantMobile: '', // 联系电话
                    areacode: [],
                    validCode: ''
                }
                this.msg = '发送验证码'
                clearInterval(this.timer)
            },
            regist(){
                this.registerModal=true;
                this.timeing=true;
                this.setTime();
            },
            setTime(){
                if(this.num>0){
                    this.num--;
                }else{
                    clearTimeout(this.timeout);
                    this.num=6;
                    this.timeing=false;
                    return;
                }
                this.timeout=setTimeout(this.setTime,1000);
            },
            /*同意*/
            handleAgree(){
                this.registerModal=false;
                this.$router.push({
                    path: '/register'
                })
            },
            handleMyRequest() {
                this.myVisiable = true
            }
        }
    };
</script>

<style scoped lang="less">
    .key__form{
        padding: 0 20px;
        .ivu-form-item{
            margin-bottom: 20px;
        }
    }
    /* 主体页面包裹 */
    .main-wrapper{
        min-width: 1200px;
        min-height: 650px;
        display: flex;
        flex-direction: column;
    }
    /* 以下是项目页面样式 */
    .h-wrapper{
        position: absolute;
        width: 100%;
        height: 100%;
    }
    .content {
        width: 100%;
        height: 100%;
        position: relative;
        background-image: url("../assets/background.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        overflow: hidden;
    }
    .content-layout {
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        height: 100%;
        z-index: 999;
    }
    .copyright-container{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #fff;
    }
    .login-form {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 712px;
        height: 360px;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0;
    }
    .login-form .my-request {
        height: 40px;
        width: 100%;
        line-height: 40px;
        padding-right: 20px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
    }
    .login-form .logo-area {
        position: relative;
        width: 280px;
        height: 100%;
        background: rgba(30,145,255,0.66);
        border-radius: 6px 0px 0px 6px;
        display: inline-block;
    }
    .login-form .form {
        position: relative;
        width: 432px;
        height: 100%;
        background: white;
        border-radius: 0px 6px 6px 0px;
        padding: 24px 36px;
        box-sizing: border-box;
        display: inline-block;
    }
    .login-form .logo-area .logo-container {
        position: absolute;
        width: 200px;
        height: 164px;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 84px;
    }
    .login-form .logo-area .logo-container img {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        width: 108px;
        height: 108px;
    }
    .login-form .logo-area .logo-container .desc {
        position: absolute;
        left: 0;
        bottom: -10px;
        right: 0;
        color: white;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        text-align: center;
    }
    .login-form .form .title {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: rgba(85,85,85,1);
        margin-bottom: 24px;
    }
</style>
<style lang="less">
    .key__form{
        .ivu-select-dropdown{
            height: 340px;
            max-height: 340px;
        }
        .ivu-cascader-menu{
            height: auto;
            max-height: 335px;
        }
    }
    .info__modal{
        .ivu-modal{
            margin-bottom: 50px;
        }
    }
    /* iview样式表单 */
    .h-form-box .ivu-form-item .ivu-input-large{
        height: 44px;
        font-size: 16px;
    }
    /*输入框前缀*/
    .h-form-box .ivu-input-with-prefix{
        padding-left: 44px;
    }
    .h-form-box .ivu-input-prefix{
        width: 44px;
    }
    .ivu-input-suffix{
            cursor: pointer;
            width:40px;
            i{
                font-size: 24px !important;
                line-height: 44px !important;
            }
        }

    .ssss[data-pwd] .ivu-input-with-prefix{
            padding-right:36px;
    }
    .h-form-box .ivu-input-wrapper-large .ivu-input-prefix i{
        line-height: 44px;
    }
    .h-form-box .ivu-input-wrapper-large.userIcon .ivu-input-prefix i {
        color: #000;
    }
    .h-form-box .ivu-input-wrapper-large.passIcon .ivu-input-prefix i {
        color: #000;
    }
    .h-login-btn .ivu-btn-large {
        padding: 10px 15px;
        font-size: 16px;
    }
</style>
